<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-11 col-sm-12 col-xs-12">
      <StorageList />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StorageList from "../../../../_shared/features/StorageList.vue";

export default {
  name: "StoragesAdmin",
  components: { StorageList },
  data() {
    return {};
  },
  methods: {},
};
</script>
